import { createComponent } from '@carvana/merch-components';
import { ElementWithProps } from '@carvana/merch-components/dist';
import cx from 'classnames';

export const CardImage = createComponent('img', {
  className: 'h-full w-full object-cover'
});

export const ImageUnavailable = createComponent('div', {
  className:
    'h-full flex items-center justify-center text-center text-text-disabled t-body-sm'
});

export const HeadlineRow = createComponent('div', {
  className: 'flex items-center justify-between gap-xl'
});

export const ImageContainer = createComponent<
  ElementWithProps<{ disabled: boolean; isFallback: boolean }>
>('div', ({ disabled, isFallback }) => ({
  className: cx('aspect-318/167 w-auto overflow-hidden', {
    '-mx-xl -mt-xl': !isFallback,
    'opacity-50': disabled
  })
}));

export const PriceContainer = createComponent('span', {
  className: 'shrink-0 whitespace-nowrap'
});

export const PriceLabel = createComponent('span', {
  className: 'text-text-default t-body-sm'
});

export const PriceValue = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('span', ({ disabled }) => ({
  className: cx(
    't-heading-md',
    disabled ? 'text-text-disabled' : 'text-text-strong'
  )
}));

export const StockCount = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const Title = createComponent<ElementWithProps<{ disabled: boolean }>>(
  'p',
  ({ disabled }) => ({
    className: cx(
      't-heading-md',
      disabled ? 'text-text-disabled' : 'text-text-strong'
    )
  })
);
